import { userConverter as _userConverter } from '@griply/services';
import { User } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

export const userConverter =
  _userConverter as unknown as FirestoreDataConverter<User>;
